/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, Input, Sidebar, SVGIcon, Table } from "@nordcloud/gnui";
import { useCustomerConfig } from "~/context/CustomerConfig/CustomerConfig";
import { useCurrency, useDisclosure } from "~/hooks";
import { currencies } from "~/tools";
import { DropButton, DropItem, IconWrap } from "./styles";

export function CurrencySelector() {
  const [search, setSearch] = React.useState("");

  const { isOpen, close, open } = useDisclosure();
  const { currency, setCurrency } = useCurrency();
  const { config } = useCustomerConfig();

  React.useEffect(() => {
    !isOpen && setSearch("");
  }, [setSearch, isOpen]);

  const options = currencies;

  if (config?.isDefaultPriority) {
    return <></>;
  }

  return (
    <>
      <DropItem>
        <DropButton onClick={open}>
          <IconWrap>
            <SVGIcon name="exchange" />
          </IconWrap>
          {currency} - change currency
        </DropButton>
      </DropItem>
      <Sidebar title="Currency Selector" isOpen={isOpen} onClick={close}>
        <Input
          type="search"
          value={search}
          name="filter"
          placeholder="Filter currencies"
          mb="1.5rem"
          onChange={(event) => setSearch(event.target.value)}
        />

        <Table striped>
          <Table.tbody>
            {options
              .filter((curr) =>
                search.length > 2
                  ? JSON.stringify(curr).match(new RegExp(search, "i"))
                  : true
              )
              .map((curr) => (
                <Table.tr key={curr.iso}>
                  <Table.td>{curr.iso}</Table.td>
                  <Table.td>{curr.name}</Table.td>
                  <Table.td>{curr.symbol_native}</Table.td>
                  <Table.td>
                    <Button
                      size="md"
                      onClick={() => {
                        if (setCurrency) {
                          setCurrency(curr.iso);
                        }
                        close();
                      }}
                    >
                      Select
                    </Button>
                  </Table.td>
                </Table.tr>
              ))}
          </Table.tbody>
        </Table>
      </Sidebar>
    </>
  );
}
